// extracted by mini-css-extract-plugin
export default {"container":"CharacterTab_container__EUq5T","img":"CharacterTab_img__GTNNS","name":"CharacterTab_name__N6QFA"};